import React from "react";
import MainPanel from "../MainPanel";
import * as S from "./style";

function TelaInicial() {
  return (
    <S.TelaInicialWrapper>
      <MainPanel />
    </S.TelaInicialWrapper>
  );
}

export default TelaInicial;
